import { ca } from '@cian/analytics';
import { toAnalyticsObjectType } from './toAnalyticsObjectType';
import { getBlockTypeByInfrastructureType } from './getBlockTypeByInfrastructureType';
import { TRegularInfrastructureItem } from '../../../types/map';

export function trackRulerClick(infrastructureItems: TRegularInfrastructureItem[], infrastructureType?: string) {
  const objectType = toAnalyticsObjectType(infrastructureType);
  const blockType = getBlockTypeByInfrastructureType(infrastructureType, infrastructureItems);

  ca('eventSite', {
    action: 'click',
    category: 'Infrastructure',
    label: 'ruler',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
